import { createSelector } from 'reselect';
import { getPageFeatureFlags } from 'src/universal/redux/page';
import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';

export const isG171Experiment = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished, getPageFeatureFlags],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-171-ApplyNow-LockIcon-Removal']?.dimensions[0]
        ?.variant === 'experiment' && oneXpDecided
    );
  }
);
